// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export {
  Operation,
  OperationDisplay,
  KnownOrigin,
  Origin,
  KnownActionType,
  ActionType,
  ErrorResponse,
  ErrorDetail,
  ErrorAdditionalInfo,
  Addon,
  AddonProperties,
  AddonPropertiesUnion,
  KnownAddonType,
  AddonType,
  KnownAddonProvisioningState,
  AddonProvisioningState,
  AddonSrmProperties,
  AddonVrProperties,
  AddonHcxProperties,
  AddonArcProperties,
  ProxyResource,
  Resource,
  SystemData,
  KnownCreatedByType,
  CreatedByType,
  ExpressRouteAuthorization,
  ExpressRouteAuthorizationProperties,
  KnownExpressRouteAuthorizationProvisioningState,
  ExpressRouteAuthorizationProvisioningState,
  CloudLink,
  CloudLinkProperties,
  KnownCloudLinkProvisioningState,
  CloudLinkProvisioningState,
  KnownCloudLinkStatus,
  CloudLinkStatus,
  Cluster,
  ClusterProperties,
  KnownClusterProvisioningState,
  ClusterProvisioningState,
  Sku,
  SkuTier,
  ClusterUpdate,
  ClusterUpdateProperties,
  ClusterZoneList,
  ClusterZone,
  Datastore,
  DatastoreProperties,
  KnownDatastoreProvisioningState,
  DatastoreProvisioningState,
  NetAppVolume,
  DiskPoolVolume,
  KnownMountOptionEnum,
  MountOptionEnum,
  ElasticSanVolume,
  PureStorageVolume,
  KnownDatastoreStatus,
  DatastoreStatus,
  GlobalReachConnection,
  GlobalReachConnectionProperties,
  KnownGlobalReachConnectionProvisioningState,
  GlobalReachConnectionProvisioningState,
  KnownGlobalReachConnectionStatus,
  GlobalReachConnectionStatus,
  HcxEnterpriseSite,
  HcxEnterpriseSiteProperties,
  KnownHcxEnterpriseSiteProvisioningState,
  HcxEnterpriseSiteProvisioningState,
  KnownHcxEnterpriseSiteStatus,
  HcxEnterpriseSiteStatus,
  Host,
  HostProperties,
  HostPropertiesUnion,
  KnownHostKind,
  HostKind,
  KnownHostProvisioningState,
  HostProvisioningState,
  KnownHostMaintenance,
  HostMaintenance,
  GeneralHostProperties,
  SpecializedHostProperties,
  IscsiPath,
  IscsiPathProperties,
  KnownIscsiPathProvisioningState,
  IscsiPathProvisioningState,
  License,
  LicenseProperties,
  LicensePropertiesUnion,
  KnownLicenseKind,
  LicenseKind,
  KnownLicenseProvisioningState,
  LicenseProvisioningState,
  VmwareFirewallLicenseProperties,
  Label,
  KnownLicenseName,
  LicenseName,
  Trial,
  KnownTrialStatus,
  TrialStatus,
  Quota,
  KnownQuotaEnabled,
  QuotaEnabled,
  Maintenance,
  MaintenanceProperties,
  KnownMaintenanceType,
  MaintenanceType,
  MaintenanceState,
  KnownMaintenanceStateName,
  MaintenanceStateName,
  KnownMaintenanceProvisioningState,
  MaintenanceProvisioningState,
  MaintenanceManagementOperation,
  MaintenanceManagementOperationUnion,
  KnownMaintenanceManagementOperationKind,
  MaintenanceManagementOperationKind,
  ScheduleOperation,
  ScheduleOperationConstraint,
  ScheduleOperationConstraintUnion,
  KnownScheduleOperationConstraintKind,
  ScheduleOperationConstraintKind,
  SchedulingWindow,
  AvailableWindowForMaintenanceWhileScheduleOperation,
  BlockedWhileScheduleOperation,
  KnownBlockedDatesConstraintCategory,
  BlockedDatesConstraintCategory,
  BlockedDatesConstraintTimeRange,
  RescheduleOperation,
  RescheduleOperationConstraint,
  RescheduleOperationConstraintUnion,
  KnownRescheduleOperationConstraintKind,
  RescheduleOperationConstraintKind,
  AvailableWindowForMaintenanceWhileRescheduleOperation,
  BlockedWhileRescheduleOperation,
  MaintenanceReadinessRefreshOperation,
  KnownMaintenanceReadinessRefreshOperationStatus,
  MaintenanceReadinessRefreshOperationStatus,
  MaintenanceReadiness,
  KnownMaintenanceCheckType,
  MaintenanceCheckType,
  KnownMaintenanceReadinessStatus,
  MaintenanceReadinessStatus,
  MaintenanceFailedCheck,
  ImpactedMaintenanceResource,
  ImpactedMaintenanceResourceError,
  MaintenanceReschedule,
  MaintenanceSchedule,
  PlacementPolicy,
  PlacementPolicyProperties,
  PlacementPolicyPropertiesUnion,
  KnownPlacementPolicyType,
  PlacementPolicyType,
  KnownPlacementPolicyState,
  PlacementPolicyState,
  KnownPlacementPolicyProvisioningState,
  PlacementPolicyProvisioningState,
  VmPlacementPolicyProperties,
  KnownAffinityType,
  AffinityType,
  VmHostPlacementPolicyProperties,
  KnownAffinityStrength,
  AffinityStrength,
  KnownAzureHybridBenefitType,
  AzureHybridBenefitType,
  PlacementPolicyUpdate,
  PlacementPolicyUpdateProperties,
  PrivateCloud,
  PrivateCloudProperties,
  ManagementCluster,
  KnownInternetEnum,
  InternetEnum,
  IdentitySource,
  KnownSslEnum,
  SslEnum,
  AvailabilityProperties,
  KnownAvailabilityStrategy,
  AvailabilityStrategy,
  Encryption,
  KnownEncryptionState,
  EncryptionState,
  EncryptionKeyVaultProperties,
  KnownEncryptionKeyStatus,
  EncryptionKeyStatus,
  KnownEncryptionVersionType,
  EncryptionVersionType,
  KnownPrivateCloudProvisioningState,
  PrivateCloudProvisioningState,
  Circuit,
  Endpoints,
  KnownNsxPublicIpQuotaRaisedEnum,
  NsxPublicIpQuotaRaisedEnum,
  KnownDnsZoneType,
  DnsZoneType,
  VcfLicense,
  VcfLicenseUnion,
  KnownVcfLicenseKind,
  VcfLicenseKind,
  Vcf5License,
  PrivateCloudIdentity,
  KnownResourceIdentityType,
  ResourceIdentityType,
  TrackedResource,
  PrivateCloudUpdate,
  PrivateCloudUpdateProperties,
  AdminCredentials,
  ProvisionedNetwork,
  ProvisionedNetworkProperties,
  KnownProvisionedNetworkProvisioningState,
  ProvisionedNetworkProvisioningState,
  KnownProvisionedNetworkTypes,
  ProvisionedNetworkTypes,
  PureStoragePolicy,
  PureStoragePolicyProperties,
  KnownPureStoragePolicyProvisioningState,
  PureStoragePolicyProvisioningState,
  ScriptCmdlet,
  ScriptCmdletProperties,
  KnownScriptCmdletProvisioningState,
  ScriptCmdletProvisioningState,
  KnownScriptCmdletAudience,
  ScriptCmdletAudience,
  ScriptParameter,
  KnownScriptParameterTypes,
  ScriptParameterTypes,
  KnownVisibilityParameterEnum,
  VisibilityParameterEnum,
  KnownOptionalParamEnum,
  OptionalParamEnum,
  ScriptExecution,
  ScriptExecutionProperties,
  ScriptExecutionParameter,
  ScriptExecutionParameterUnion,
  KnownScriptExecutionParameterType,
  ScriptExecutionParameterType,
  ScriptSecureStringExecutionParameter,
  ScriptStringExecutionParameter,
  PSCredentialExecutionParameter,
  KnownScriptExecutionProvisioningState,
  ScriptExecutionProvisioningState,
  ScriptPackage,
  ScriptPackageProperties,
  KnownScriptPackageProvisioningState,
  ScriptPackageProvisioningState,
  ResourceSku,
  KnownResourceSkuResourceType,
  ResourceSkuResourceType,
  ResourceSkuLocationInfo,
  ResourceSkuZoneDetails,
  ResourceSkuCapabilities,
  ResourceSkuRestrictions,
  KnownResourceSkuRestrictionsType,
  ResourceSkuRestrictionsType,
  ResourceSkuRestrictionInfo,
  KnownResourceSkuRestrictionsReasonCode,
  ResourceSkuRestrictionsReasonCode,
  VirtualMachine,
  VirtualMachineProperties,
  KnownVirtualMachineProvisioningState,
  VirtualMachineProvisioningState,
  KnownVirtualMachineRestrictMovementState,
  VirtualMachineRestrictMovementState,
  VirtualMachineRestrictMovement,
  WorkloadNetwork,
  WorkloadNetworkProperties,
  KnownWorkloadNetworkProvisioningState,
  WorkloadNetworkProvisioningState,
  WorkloadNetworkDhcp,
  WorkloadNetworkDhcpEntity,
  WorkloadNetworkDhcpEntityUnion,
  KnownDhcpTypeEnum,
  DhcpTypeEnum,
  KnownWorkloadNetworkDhcpProvisioningState,
  WorkloadNetworkDhcpProvisioningState,
  WorkloadNetworkDhcpServer,
  WorkloadNetworkDhcpRelay,
  WorkloadNetworkDnsService,
  WorkloadNetworkDnsServiceProperties,
  KnownDnsServiceLogLevelEnum,
  DnsServiceLogLevelEnum,
  KnownDnsServiceStatusEnum,
  DnsServiceStatusEnum,
  KnownWorkloadNetworkDnsServiceProvisioningState,
  WorkloadNetworkDnsServiceProvisioningState,
  WorkloadNetworkDnsZone,
  WorkloadNetworkDnsZoneProperties,
  KnownWorkloadNetworkDnsZoneProvisioningState,
  WorkloadNetworkDnsZoneProvisioningState,
  WorkloadNetworkGateway,
  WorkloadNetworkGatewayProperties,
  WorkloadNetworkPortMirroring,
  WorkloadNetworkPortMirroringProperties,
  KnownPortMirroringDirectionEnum,
  PortMirroringDirectionEnum,
  KnownPortMirroringStatusEnum,
  PortMirroringStatusEnum,
  KnownWorkloadNetworkPortMirroringProvisioningState,
  WorkloadNetworkPortMirroringProvisioningState,
  WorkloadNetworkPublicIP,
  WorkloadNetworkPublicIPProperties,
  KnownWorkloadNetworkPublicIPProvisioningState,
  WorkloadNetworkPublicIPProvisioningState,
  WorkloadNetworkSegment,
  WorkloadNetworkSegmentProperties,
  WorkloadNetworkSegmentSubnet,
  WorkloadNetworkSegmentPortVif,
  KnownSegmentStatusEnum,
  SegmentStatusEnum,
  KnownWorkloadNetworkSegmentProvisioningState,
  WorkloadNetworkSegmentProvisioningState,
  WorkloadNetworkVirtualMachine,
  WorkloadNetworkVirtualMachineProperties,
  KnownVMTypeEnum,
  VMTypeEnum,
  WorkloadNetworkVMGroup,
  WorkloadNetworkVMGroupProperties,
  KnownVMGroupStatusEnum,
  VMGroupStatusEnum,
  KnownWorkloadNetworkVMGroupProvisioningState,
  WorkloadNetworkVMGroupProvisioningState,
  KnownMaintenanceStatusFilter,
  MaintenanceStatusFilter,
  KnownScriptOutputStreamType,
  ScriptOutputStreamType,
  KnownVersions,
} from "./models.js";
